export default __webpack_public_path__ + "static/hand-6ab48cd4a9d03bd13fb4fbfa4b41e1b1.png";